module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 11-03-41-207.ff581862.mp4";